// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"302":"f75b4b1d","369":"b67d87f4","478":"3d34fee0"}[chunkId] + ".chunk.css";
};